import React from "react";

import SearchPropertyCard from "../../enhancers/SearchPropertyCard";
import SearchPropertyPopup from "../../enhancers/SearchPropertyPopup";

// import SearchBar from "./sections/search-bar";
import SearchBar from "../search-rental-housing/sections/search-bar";
import SearchView from "@coninsa-site/project/src/pages/search-view/search-view";
import Container from "@coninsa-s2/container";
import Heading from "@coninsa-s2/heading";
import { BuyPropertiesFrequentSearch } from "../../sections/frequent-search/controller/BuyPropertiesFrequentSearch";

import searchBuyPropertiesConfigs from "../../facets/search-buy-properties";

const normalizeBuyUrl = (originalUrl: string) => {
  if (!originalUrl) return "#";

  // 👇 si trae "corretaje", siempre lo cambiamos por "venta"
  if (originalUrl.includes("corretaje")) {
    return originalUrl.replace("corretaje", "venta");
  }

  return originalUrl;
};


export const SearcRentalPage: React.FC = ({
  navigate = (url) => console.log(url),
}) => {
  return (
    <div>
      <SearchView
        navigate={navigate}
        searchBar={SearchBar}
        itemCard={(props) => <SearchPropertyCard {...props} normalizeUrl={normalizeBuyUrl} />}
        popupCard={SearchPropertyPopup}
        configs={searchBuyPropertiesConfigs}
      />

      <div>
        <Container>
          <Heading
            as="h2"
            tint="teal"
            size="4xl"
            condensed
            className="mt-10 lg:mt-16 mb-6"
          >
            Búsquedas <span className="is-highlighted">frecuentes</span>
          </Heading>
        </Container>
        <BuyPropertiesFrequentSearch title="Venta de inmuebles usados" />
      </div>
    </div>
  );
};

export default SearcRentalPage;
